import sanityClient from '@sanity/client'

export default sanityClient({
  projectId: 'o5lg176f', // YOUR_SANITY_PROJECT_ID
  dataset: 'production',
})
